import { useSelector } from "react-redux";

import type { IAppConfigState, MagicoColorKey, MagicoColors } from "../models/AppConfigModels";
import { selectAppColors, selectAppConfig, selectAppConfigs, selectAppImages, selectAppLogo } from "../store/slices/appConfig";

interface UseAppConfigReturn {
  appConfig: IAppConfigState;
  logo: string;
  colors: MagicoColors;
  images: Record<string, string>;
  configs: Record<string, string>;
  staticPages: Record<string, any>;
  // Helper functions to get specific values
  getColor: (colorKey: MagicoColorKey, fallback?: string) => string;
  getImage: (imageKey: string, fallback?: string) => string;
  getConfig: (configKey: string, fallback?: string) => string;
}

export const useAppConfig = (): UseAppConfigReturn => {
  const appConfig = useSelector(selectAppConfig);
  const logo = useSelector(selectAppLogo);
  const colors = useSelector(selectAppColors);
  const images = useSelector(selectAppImages);
  const configs = useSelector(selectAppConfigs);

  const getColor = (colorKey: MagicoColorKey, fallback = ""): string => {
    return colors[colorKey] || fallback;
  };

  const getImage = (imageKey: string, fallback = ""): string => {
    return images[imageKey] || fallback;
  };

  const getConfig = (configKey: string, fallback = ""): string => {
    return configs[configKey] || fallback;
  };

  return {
    appConfig,
    logo,
    colors,
    images,
    configs,
    staticPages: appConfig.static_pages,
    getColor,
    getImage,
    getConfig,
  };
};